import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();

  console.log('Auth interceptor called for:', req.url);
  console.log('Token available:', !!token);

  if (token) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    console.log('Authorization header set:', authReq.headers.get('Authorization'));
    
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized responses
        if (error.status === 401) {
          console.log('🔒 Session expired or invalid token. Redirecting to login...');
          
          // Clear the invalid session
          authService.logout();
          
          // Redirect to login page
          router.navigate(['/login'], { 
            queryParams: { 
              reason: 'session_expired',
              returnUrl: router.url 
            } 
          });
        }
        
        return throwError(() => error);
      })
    );
  }

  console.log('No token found, proceeding without auth header');
  return next(req);
};
